import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { Click, ClicksResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class ClicksDataService {

  private uri: string = `${environment.apiUrl}clicks`;
  private cacheKey: string = 'clicks.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getClick(id: number): Observable<Click|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getClicks(parameters: {[param: string]: string | string[]}): Observable<ClicksResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addClick(data: Click): Observable<Click|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addClicks(data: Click[]): Observable<Click[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateClick(data: Click): Observable<Click|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateClicks(data: Click[]): Observable<Click[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchClick(data: Click): Observable<Click|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchClicks(data: Click[]): Observable<Click[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteClick(data: Click): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteClicks(data: Click[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((click) => {
      ids.push(click.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
